export { default as EventManager } from './event-manager';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/mjolnir.js/dist/esm/index.js
// module id = 680
// module chunks = 0 1